module.exports = __webpack_public_path__ + "static/adolphus-opara-51ee47ccbe061957e4dfbcb2b1c02250.jpg";